import { ItemStatusEnum } from '../../graphql/graphql';

export const profileItemStatuses = {
  all: 'ALL',
  validated: 'VALIDATED_AND_AWAITING_PAYMENT',
  published: 'PUBLISHED',
  expired: 'EXPIRED',
  pending: 'PENDING',
  rejected: 'REJECTED'
};

export const profileItemStateLabels = {
  [ItemStatusEnum.Published]: 'pages.profile.filters.ready',
  [ItemStatusEnum.AwaitingPayment]:
    'pages.profile.items_state.awaiting_payment',
  [ItemStatusEnum.Validated]: 'pages.profile.items_state.awaiting_payment',
  [ItemStatusEnum.Expired]: 'pages.profile.filters.expired',
  [ItemStatusEnum.Pending]: 'pages.profile.filters.in_process',
  [ItemStatusEnum.Rejected]: 'pages.profile.items_state.rejected'
};
